import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'lodash';

export default {
  getRiskList({ status, q } = {}) {
    return api.get('/risk_managements', {
      params: omitBy({ status, q }, isNil),
    });
  },
  createRisk(payload) {
    return api.post('/risk_managements', payload);
  },
  getRiskDetail(id) {
    return api.get(`/risk_managements/${id}`);
  },
  updateRisk(id, payload) {
    return api.put(`/risk_managements/${id}`, payload);
  },
  reactivateRisk(id) {
    return api.put(`/risk_managements/${id}/reactivate`);
  },
  deactivateRisk(id) {
    return api.delete(`/risk_managements/${id}`);
  },
  deleteRisk(id) {
    return api.delete(`/risk_managements/${id}/delete`);
  },
  getRentDurationList() {
    return api.get('/risk_managements/rent_durations');
  },
};
